import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SpinnerComponent } from '@app-shared/components/spinner/spinner.component';

@Component({
  selector: 'app-okta-auth-placeholder',
  templateUrl: './okta-auth-placeholder.component.html',
  styleUrls: ['./okta-auth-placeholder.component.scss'],
  imports: [SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OktaAuthPlaceholderComponent {}
